import { createActionGroup, emptyProps, props } from "@ngrx/store";
import {
    FormMutationType,
    FormQuestionDraft,
    FormSection,
    FormSignature,
    FormSubsection,
    ManagedForm,
} from "../models/form.models";

export const FormsActions = createActionGroup({
    source: "Forms",
    events: {
        "Page Opened": emptyProps(),
        "Data Loaded": props<{
            forms: ManagedForm[];
            subsections: FormSubsection[];
        }>(),
        "Data Load Failed": emptyProps(),
        "Form Selected": props<{ formId: string }>(),
        "Form Query Changed": props<{ query: string }>(),
        "Question Query Changed": props<{ query: string }>(),
        "Section Changed": props<{ section: FormSection }>(),
        "Subsection Toggled": props<{ subsectionId: string }>(),
        "Create Requested": props<{ title: string }>(),
        "Create Succeeded": props<{ form: ManagedForm }>(),
        "Duplicate Requested": props<{ form: ManagedForm }>(),
        "Duplicate Succeeded": props<{ form: ManagedForm }>(),
        "Update Form Requested": props<{
            form: ManagedForm;
            mutationType: FormMutationType;
        }>(),
        "Update Form Succeeded": props<{
            form: ManagedForm;
            mutationType: FormMutationType;
        }>(),
        "Delete Requested": props<{ formId: string }>(),
        "Delete Succeeded": props<{ formId: string }>(),
        "Create Subsection Requested": props<{
            form: ManagedForm;
            title: string;
        }>(),
        "Create Subsection Succeeded": props<{
            form: ManagedForm;
            subsection: FormSubsection;
        }>(),
        "Update Subsection Requested": props<{
            form: ManagedForm;
            subsection: FormSubsection;
        }>(),
        "Update Subsection Succeeded": props<{
            subsection: FormSubsection;
            mutationType: FormMutationType;
        }>(),
        "Delete Subsection Requested": props<{
            form: ManagedForm;
            subsectionId: string;
        }>(),
        "Delete Subsection Succeeded": props<{
            form: ManagedForm;
            subsectionId: string;
        }>(),
        "Reorder Subsections Requested": props<{
            form: ManagedForm;
            previousIndex: number;
            currentIndex: number;
        }>(),
        "Question Save Requested": props<{
            form: ManagedForm;
            subsection: FormSubsection;
            questionIndex: number | null;
            draft: FormQuestionDraft;
        }>(),
        "Delete Question Requested": props<{
            form: ManagedForm;
            subsection: FormSubsection;
            questionIndex: number;
        }>(),
        "Reorder Questions Requested": props<{
            form: ManagedForm;
            subsection: FormSubsection;
            previousIndex: number;
            currentIndex: number;
        }>(),
        "Signatures Save Requested": props<{
            form: ManagedForm;
            signatures: FormSignature[];
        }>(),
        "Mutation Failed": emptyProps(),
        "Mutation Status Cleared": emptyProps(),
    },
});
